import React, { useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Collapsible from '../../../../components/Collapsible/Collapsible';
import { ToggleSwitch } from '../../../../components/Toogle';
import TopCategories from './TopCategories';
import { RootStateOrAny, useSelector } from 'react-redux';

interface Props {
    quick_sales?: boolean;
}


const TopicalClassification = withRouter((props: RouteComponentProps & Props) => {
    const { quick_sales } = props;
    const [verbatimToggleValue, setVerbatimToggleValue] = useState(true);

    const { topic_categories: dissatisfactionTopicCategories, data: dissatisfactionChartData } = useSelector(
        (state: RootStateOrAny) => quick_sales ? state.voc.voc_quick_sales_topic_classification_dissatisfaction ?? {} : state.voc.voc_after_sales_topic_classification_dissatisfaction ?? {}
      );
      const dissatisfactionTopicVerbatim = useSelector((state: RootStateOrAny) => quick_sales ? state.voc.voc_quick_sales_topic_verbatim_dissatisfaction ?? {} : state.voc.voc_after_sales_topic_verbatim_dissatisfaction ?? {});
      

      const dissatisfactionTopicClassificationLoading = useSelector((state: RootStateOrAny) => quick_sales ? state.loading.voc_quick_sales_topic_classification_dissatisfaction : state.loading.voc_after_sales_topic_classification_dissatisfaction);
      const dissatisfactionVerbatimLoading = useSelector((state: RootStateOrAny) => quick_sales ? state.loading.voc_quick_sales_topic_verbatim_dissatisfaction : state.loading.voc_after_sales_topic_verbatim_dissatisfaction);
      
      
        const { topic_categories: satisfactionTopicCategories, data: satisfactionChartData } = useSelector(
          (state: RootStateOrAny) => quick_sales ? state.voc.voc_quick_sales_topic_classification_satisfaction ?? {} : state.voc.voc_after_sales_topic_classification_satisfaction ?? {}
        );
        const satisfactionTopicVerbatim = useSelector((state: RootStateOrAny) => quick_sales ? state.voc.voc_quick_sales_topic_verbatim_satisfaction ?? {} : state.voc.voc_after_sales_topic_verbatim_satisfaction ?? {});
        
        const satisfactionTopicClassificationLoading = useSelector((state: RootStateOrAny) => quick_sales ? state.loading.voc_quick_sales_topic_classification_satisfaction : state.loading.voc_after_sales_topic_classification_satisfaction);
        const satisfactionVerbatimLoading = useSelector((state: RootStateOrAny) => quick_sales ? state.loading.voc_quick_sales_topic_verbatim_satisfaction : state.loading.voc_after_sales_topic_verbatim_satisfaction);

    return (
        <Collapsible
            title={"Categories and verbatims"}
            tooltipText="WIP: we keep on improving the topic classification"
            show={true}
            toggle={
                <ToggleSwitch
                    activeToggleLabel={"Ratings from 1 to 3"}
                    inactiveToggleLabel={"Ratings from 4 to 5"}
                    active={verbatimToggleValue}
                    handleToggleClick={() => {
                        setVerbatimToggleValue((prevState) => !prevState);
                    }}
                    toggleClassName={"filter_toggle"}
                />
            }
        >
            <TopCategories
                categories={verbatimToggleValue ? dissatisfactionTopicCategories : satisfactionTopicCategories}
                chartData={verbatimToggleValue ? dissatisfactionChartData : satisfactionChartData}
                topicClassificationLoading={
                    verbatimToggleValue ? dissatisfactionTopicClassificationLoading : satisfactionTopicClassificationLoading
                }
            />
        </Collapsible>

    )

});

export default TopicalClassification;